<template>
  <ratings-loading-skeleton v-if="loading" />
  <div v-else>
    <router-view :sitter="sitter" />
  </div>
</template>

<script lang="ts">
import { gql } from '@apollo/client/core';
import RatingsLoadingSkeleton from './RatingsLoadingskeleton.vue';

export default {
  name: 'RatingsApp',
  components: { RatingsLoadingSkeleton },
  props: {
    sitterId: {
      type: String,
      required: true,
    },
  },
  data(): any {
    return {
      sitter: null,
      loading: true,
    };
  },
  apollo: {
    sitter: {
      query: gql`
        query ($id: UUID!) {
          account(id: $id, kind: SITTER) {
            id
            name
            photoUrl
          }
        }
      `,
      variables(): any {
        return {
          id: this.sitterId,
        };
      },
      update(data): any {
        return data.account;
      },
      result() {
        this.loading = false;
      },
    },
  },
};
</script>
